import app from '../angular_app.es6';

app.controller('OpenEndsScreenshotsController', ['$scope', ($scope) => {

  $scope.data = {};

  $scope.init = (data) => {
    $scope.data = data.data;
    $scope.metric = data.metric;
  };

}]);